interface Props {
    image: string;
    alt: string;
}

export const PartnerCardComponent = (props: Props) => {
    return (
        <div className="h-[140] w-[140px]">
            <img className="opacity-50 grayscale" src={props.image} alt={props.alt} />
        </div>
    );
};
